import { LoginResponse } from '@/services/api.types';

// FKA org delimitation R3 — FKO (the national organisation registry) is
// consulted on every login to validate the units the FKA assertion granted.
// When that call degrades the backend does NOT block the login: the existing
// bindings are frozen (nothing is ever deleted on an error path) and the login
// response says so. The user gets in; what they may be looking at is a
// possibly-stale set of organisations, which is what the dialog tells them.
//
// WIRE POSITION (confirmed with the rpms leg 2026-08-12): proto `fko_degraded`
// (field 4, bool) → protojson `fkoDegraded`, at the TOP LEVEL of TotpReply,
// SIBLING to the completed/pending oneof rather than inside it. That is
// deliberate: the degraded state is ufs's own observation about the registry
// and is orthogonal to which branch the tenant module's login transaction took
// — so it appears on a pending reply too.
//
// Reading it defensively is not vagueness about the contract, it is the
// correct failure mode for THIS signal: treating an unrecognised shape as
// "degraded" would raise a dialog on every ordinary login, far worse than
// staying quiet.
//
// WHEN to act on it is NOT decided here — see advanceLoginStep, which only
// raises the notice once the login transaction completes.
export const readFkoDegraded = (resp: LoginResponse | undefined): boolean =>
  resp?.fkoDegraded === true;
